<template>
  <div
    class="container no-margin grid-container grid-container--6-6 custom-container phone-container"
  >
    <select-autocomplete
      class="col1 col-area"
      placeholder="Ej: 11"
      label="Cód. de área"
      maxlength="4"
      v-model="value.area"
      name="area"
      inputmode="numeric"
      :required="required"
      :items="codigosAreaPopulares"
      :validationError="validationError.area"
      :scroll-on-focus="scrollOnFocus"
      @input="onInput"
      @click="trackClick('codigoAreaCelular')"
      analyticsName="cód. de área"
      :analyticsSubmodule="analyticsSubmodule"
      :quantumObfuscate="quantumObfuscate"
    />
    <number-input
      class="col2 col-number"
      placeholder="Ej: 43464800"
      label="Número"
      name="numero"
      :maxlength="maxLengthNumber"
      v-model="value.numero"
      :required="required"
      :validationError="validationError.numero"
      :scroll-on-focus="scrollOnFocus"
      @input="onInput"
      @click="trackClick('numeroCelular')"
      analyticsName="número"
      :analyticsSubmodule="analyticsSubmodule"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import { codigosAreaPopulares } from "@/config/constants";
import NumberInput from "@/__tests-ab__/AR2024CNOMV2/components/core/NumberInput";
import SelectAutocomplete from "@/__tests-ab__/AR2024CNOMV2/components/core/custom/SelectAutocomplete";
import { DO_CLICK_TRACKING } from "@/config/constants/action-types";

export default {
  name: "PhoneNumber",
  components: { NumberInput, SelectAutocomplete },
  props: {
    label: String,
    value: Object,
    name: String,
    required: Boolean,
    scrollOnFocus: {
      type: Boolean,
      default: true
    },
    analyticsSubmodule: {
      type: String,
      default: null
    },
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validationError: { area: null, numero: null },
      checked: false
    };
  },
  methods: {
    onInput() {
      if (this.checked) {
        this.isValid(this.value);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid(this.value);
    },
    isValid(val) {
      let error = { area: true, numero: true, total: true };
      const isAreaValid = !isNaN(parseFloat(val.area)) && isFinite(val.area);
      const isNumberValid =
        !isNaN(parseFloat(val.numero)) && isFinite(val.numero);

      if (isAreaValid && val.area.length >= 2 && val.area.length <= 4) {
        // El valor es válido
        this.validationError.area = null;
        error.area = false;
      }
      if (isNumberValid && val.numero.length >= 6 && val.numero.length <= 8) {
        this.validationError.numero = null;
        error.numero = false;
      }
      if (
        isNumberValid &&
        isAreaValid &&
        (val.area + val.numero).length === 10
      ) {
        this.validationError.area = null;
        this.validationError.numero = null;
        error.total = false;
      }
      if (error.area) {
        this.validationError.area =
          val.area.length > 0
            ? "El código de área no es válido"
            : "Tenés que ingresar este dato";
        return false;
      }

      if (error.numero) {
        this.validationError.numero =
          val.numero.length > 0
            ? "El número no es válido"
            : "Tenés que ingresar este dato";
        return false;
      }

      if (error.total) {
        this.validationError.numero = "El número no es válido";
        return false;
      }

      return true;
    },
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(DO_CLICK_TRACKING, el);
    }
  },
  computed: {
    codigosAreaPopulares() {
      return codigosAreaPopulares;
    },
    maxLengthNumber() {
      switch (this.value.area.length) {
        case 3:
          return "7";
        case 4:
          return "6";
        default:
          return "8";
      }
    }
  }
};
</script>

<style scoped>
.col-area {
  width: 50%;
}

.col-number {
  width: 50%;
}

@media screen and (max-width: 1024px) {
  .col-area {
    width: 100%;
  }

  .col-number {
    width: 100%;
  }
}
</style>
